const setNoScore = (productPayload, noScore) => {
  if (noScore !== undefined) {
    productPayload.append('product[no_score]', noScore)
  }
}

const setNoSkip = (productPayload, noSkip) => {
  if (noSkip !== undefined) {
    productPayload.append('product[no_skip]', noSkip)
  }
}

const setManagerApproval = (productPayload, managerApproval) => {
  productPayload.append('product[manager_approval]', managerApproval)
}

const setProductType = (productPayload, productType) => {
  if (productType !== undefined) {
    productPayload.append('product[product_type]', productType)
  }
}

const setContentLink = (productPayload, contentLink) => {
  // Content link can be string, null or undefined.
  // If it is anything else than a string, then we want to unset it.
  const fixedContentLink = contentLink ?? ''
  productPayload.append(`product[content_link]`, fixedContentLink)
}

const setAppStoreLink = (productPayload, appStoreLink) => {
  if (appStoreLink !== undefined) {
    productPayload.append(
      'product[properties][apple_store_appid]',
      appStoreLink
    )
  }
}

const setGooglePlayLink = (productPayload, googlePlayLink) => {
  if (googlePlayLink !== undefined) {
    productPayload.append(
      'product[properties][google_play_package_name]',
      googlePlayLink
    )
  }
}

const setImageFile = (productPayload, imageFile) => {
  if (imageFile instanceof File) {
    productPayload.append('image_file', imageFile)
  }
}

const setContentFile = (productPayload, contentFile) => {
  if (contentFile !== undefined) {
    productPayload.append('content_file', contentFile)
  }
}

const setSupportedPlatforms = (productPayload, supportedPlatforms) => {
  if (Array.isArray(supportedPlatforms)) {
    productPayload.append(
      'product[properties][supported_platforms]',
      supportedPlatforms.join()
    )
  }
}

const setProductDescriptions = (productPayload, formData, localeCodes) => {
  localeCodes.forEach((localeCode) => {
    const title = formData.title[localeCode]
    const long_description = formData.description_long[localeCode]

    if (title !== undefined) {
      productPayload.append(`product[title][${localeCode}]`, title)
    }
    if (long_description !== undefined) {
      productPayload.append(
        `product[description_long][${localeCode}]`,
        long_description
      )
    }
  })
}

const buildProductPayload = (config) => {
  const productPayload = new FormData()
  const form = config.data

  // set required fields
  setProductType(productPayload, config.type)
  setProductDescriptions(productPayload, form, config.localeCodes)
  setImageFile(productPayload, form.image_file)

  // set optional fields
  if (config.settings.content_link) {
    // set default content link (QuizRace)
    // localized content links are added via separate endpoint
    setContentLink(productPayload, form.content_link)
  }
  if (config.settings.supported_platforms) {
    setSupportedPlatforms(productPayload, form.supported_platforms || [])
  }

  if (config.settings.content_file) {
    setContentFile(productPayload, form.content_file)
  }

  if (config.settings.app_store_link) {
    setAppStoreLink(productPayload, form.apple_store_appid)
  }
  if (config.settings.google_play_link) {
    setGooglePlayLink(productPayload, form.google_play_package_name)
  }

  if (config.settings.no_score) {
    setNoScore(productPayload, form.no_score)
  }

  if (config.settings.no_skip) {
    setNoSkip(productPayload, form.no_skip)
  }

  if (config.settings.manager_approval) {
    setManagerApproval(productPayload, form.manager_approval)
  }

  return productPayload
}

export default buildProductPayload
